   
    var GenesysChat = {
        constants: {
            chatBotDeploymentId: $("#liveChatDeploymentId").val(),
            country: countryCode,
            languageCountry: storeLanguage+"-"+countryCode,
            genesysApp: '.genesys-app',
            environment: $("#liveChatEnvironment").val(),
            genesysUrl : (countryCode == "US" || countryCode == "CA") ? "https://apps.mypurecloud.com/genesys-bootstrap/genesys.min.js" : "https://apps.mypurecloud.ie/genesys-bootstrap/genesys.min.js"
        },

        init: function() {
        
            (function (g, e, n, es, ys) {
                    g['_genesysJs'] = e;
                    g[e] = g[e] || function () {
                    (g[e].q = g[e].q || []).push(arguments)
                    };
                    g[e].t = 1 * new Date();
                    g[e].c = es;
                    ys = document.createElement('script');
                    ys.async = 1;
                    ys.src = n;
                    ys.charset = 'utf-8'; 
                    document.head.appendChild(ys);
                    
                })(window, 'Genesys', GenesysChat.constants.genesysUrl, {
                    environment: GenesysChat.constants.environment,
                    deploymentId:  GenesysChat.constants.chatBotDeploymentId
                });

                Genesys("command", "Database.set", { messaging: { customAttributes: { 
                        "webmsg_brandcode": brandCodeLivechat, 
                        "webmsg_country": countryCode, 
                        "webmsg_language": storeLanguage+"-"+countryCode
                    }}})

                    this.bind();
        },

        bind: function() {
            // Contenenete logiche di binding, 
            // gestite tramite hook di Genesys per poter, ad esempio, 
            // tracciare gli analytics in caso di apertura o chiusura della chat
            
            Genesys('subscribe', 'Messenger.ready', function(o) {
            	if(sessionStorage.showHelpChatbot != null && $('#chatbot-element').length > 0 ){
                	$('#chatbot-element').show();
                }
            	$('[aria-label="chat with us"]').css('pointer-events','unset');
                $(GenesysChat.constants.genesysApp).hide();
                $(GenesysChat.constants.genesysApp).attr("data-analytics_available_call", "0");
            });

            Genesys('subscribe', 'MessagingService.messagesReceived', function(o) {
                if (o.data.messages[0].direction === 'Inbound') {//only messange send by user
                    tealium_data2track.push({
                        'id': 'Click',
                        'data_element_id': 'X_X_ChatBot_Send',
                        'data_analytics_available_call': '1',
                    });
                }
            });
            Genesys('subscribe', 'Conversations.opened', function(o) {            
                
                
            });

            Genesys('subscribe', 'Conversations.closed', function(o) {
                GenesysChat.hideChat();

                tealium_data2track.push({
                    'id': 'Click',
                    'data_element_id': 'X_X_ChatBot_Close',
                    'data_analytics_available_call': '1',
                });                
            });

            
        },

        startChatbot: function(e) {
            // Avvio della chat Genesys
        	 Genesys("command", "Database.set", { messaging: { customAttributes: { 
                 "webmsg_brandcode": brandCodeLivechat, 
                 "webmsg_country": countryCode, 
                 "webmsg_language": storeLanguage+"-"+countryCode
             }}});
            GenesysChat.showChat();
            Genesys("command", "Messenger.open", {},
                function(o){}, // if resolved
                function(o){ // if the chat is opened but not dispyable 
                    GenesysChat.showChat();
                }
            );
        },

        openChat: function(e) {
        	if($('#genesys-mxg-container-frame').length >0){
            // Apertura della chat
            if($(".contact-us-form").length == 0){ 
                sessionStorage.setItem('chatbotOpened', true); //save chat is opened no in contact us page
            }
            tealium_data2track.push({
                'id':'Click',
                'data_element_id':'X_X_ChatBot_Open', 
                'data_analytics_available_call':'1',
                });
            GenesysChat.startChatbot();
            GenesysChat.showChat();
            sessionStorage.setItem("showHelpChatbot",true);
        	}
        },

        showChat: function(e) {
            // Visualizzazione della chat
        // $(GenesysChat.constants.helpButton).hide();
            $(GenesysChat.constants.genesysApp).show();
            $('#chatbot-element').hide();
        },

        hideChat: function(e) {
            $(GenesysChat.constants.genesysApp).hide();
            if(sessionStorage.showHelpChatbot != null && $('#chatbot-element').length > 0 ){
            	$('#chatbot-element').show();
            }
            sessionStorage.setItem("chatbotOpened",false);
        },

        onLoadHandler: function() {
            
          //calculate margin to hide entry point when touch the footer
            var margin;
            if(isOliver){
            	if((window.mobilecheck() || window.tabletPortraitCheck())){
            		margin = ($('#chatbot-element').height() + parseFloat($('#chatbot-element').css('padding-top')) + parseFloat($('#chatbot-element').css('padding-bottom')))*4 + 'px';
            	}else{
            		margin = ($('#chatbot-element').height() + parseFloat($('#chatbot-element').css('padding-top')) + parseFloat($('#chatbot-element').css('padding-bottom')))*2 + 'px';
            	}
            }else{
            	margin = ($('#chatbot-element').height() + parseFloat($('#chatbot-element').css('padding-top')) + parseFloat($('#chatbot-element').css('padding-bottom')))*1.5 + 'px';
            }
            
            var options = {
            	root: null,
                rootMargin: margin,
                threshold: 0.5
            }
            var observer = new IntersectionObserver(GenesysChat.onScrollHandler, options);
            	
            var footerDesk = document.querySelector('#footer-content-area');
            observer.observe(footerDesk);
        },
        onScrollHandler: function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                	$('#chatbot-element').hide();
                } else {
                	if(sessionStorage.showHelpChatbot != null && $('#chatbot-element').length > 0 && $('#genesys-messenger').is(":hidden"))
                		$('#chatbot-element').show();
                }
            });
        }
    }

  
    GenesysChat.init();
        
    $(document).ready(function (){
    	GenesysChat.onLoadHandler();
    });

